import APIError from '../APIError';

class SecondaryMarketPropertyError extends APIError {
  constructor(code, details = null) {
    super(code, 'SecondaryMarketPropertyError', details);
  }
}

export default SecondaryMarketPropertyError;
